export default "__VITE_ASSET__$IwfeYOz__"